import { CherryHubDataApi } from "../../api/dataApiModels";
import {
  Box,
  VStack,
  Text,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Skeleton,
  SkeletonText,
  HStack,
} from "@chakra-ui/react";
import React, { useEffect, useRef, useState } from "react";
import { useDataApiClient, useAdminApiClient } from "../../hooks/useApiClient";
import { Card } from "../Card/Card";

interface EnvironmentDetailProps {
  env?: CherryHubDataApi.Environment;
  isLoading?: boolean;
}

export const EnvironmentDetail = (props: EnvironmentDetailProps) => {
  const selfFetch = props.env === undefined && props.isLoading === undefined;
  const isMounted = useRef(true);
  const [env, setEnv] = useState<CherryHubDataApi.Environment | undefined>(
    props.env
  );
  const apiClient = useDataApiClient();
  const setEnvironment = async () => {
    const result = await apiClient.getEnvironment();
    if (result.ok && isMounted.current) {
      setEnv(result.data);
    }
  };

  useEffect(() => {
    if (selfFetch) {
      setEnvironment();
    }
  }, [isMounted]);

  useEffect(() => {
    if (!selfFetch) {
      setEnv(props.env);
    }
  }, [props.env]);

  const isLoading = selfFetch ? env == null : props.isLoading ?? false;

  return (
    <Card w="100%" overflowX="auto">
      <VStack w="100%" spacing="4">
        {(!isLoading && env && (
          <Box textAlign="left" w="100%">
            <Text>
              <b>Api Version</b> : {env?.ApiVersion}
            </Text>
            <Text>
              <b>Api Last Started</b> : {env?.ApiLastStarted}
            </Text>
            <Text>
              <b>Api Last Started Ago</b> : {env?.ApiLastStartedAgo}
            </Text>
            <Text>
              <b>Configuration Last Loaded</b> : {env?.ConfigurationLastLoaded}
            </Text>
            <Text>
              <b>Configuration Last Loaded Ago</b> :{" "}
              {env?.ConfigurationLastLoadedAgo}
            </Text>
            <Text>
              <b>Environment</b> : {env?.Environment}
            </Text>
            <Text>
              <b>Build Configuration</b> : {env?.BuildConfiguration}
            </Text>
            <Text>
              <b>Remote Ip Address</b> : {env?.RemoteIpAddress}
            </Text>
            <Text>
              <b>Referenced Assemblies</b> :
            </Text>
            <Table size="sm">
              <Thead>
                <Tr>
                  <Th>Assembly</Th>
                  <Th>Version</Th>
                </Tr>
              </Thead>
              <Tbody>
                {env &&
                  env?.ReferencedAssemblies?.map((ref, i) => {
                    return (
                      <Tr key={i}>
                        <Td>{ref.Key}</Td>
                        <Td>{ref.Value}</Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </Box>
        )) || (
          <>
            <Box width="100%" padding="6" boxShadow="lg">
              <SkeletonText mt="4" noOfLines={4} spacing="4" width="30%" />
              <HStack mt="4">
                <Box width="80%" padding="6" boxShadow="lg">
                  <Skeleton height="40px" />
                  <SkeletonText mt="4" noOfLines={12} spacing="4" />
                </Box>
                <Box width="20%" padding="6" boxShadow="lg">
                  <Skeleton height="40px" />
                  <SkeletonText mt="4" noOfLines={12} spacing="4" />
                </Box>
              </HStack>
            </Box>
          </>
        )}
      </VStack>
    </Card>
  );
};
